import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHalfScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_2568_126016",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 2.5,
				y: 2.5,
				width: 15,
				height: 15,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 15,
			height: 15,
			rx: 1,
			stroke: "#636C7B",
			strokeWidth: 3,
			mask: "url(#path-1-inside-1_2568_126016)"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.083,
			y1: 2.5,
			x2: 10.083,
			y2: 16.6667,
			stroke: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 3.33337,
			width: 6.66667,
			height: 13.3333,
			fill: "#636C7B"
		})
	]
});
export default SvgHalfScreen;
